<template>
  <div>
      <!------------------------search---------------------->
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-date-picker
              v-model="query.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchStat">查询</el-button>
          </el-form-item>
        </el-form>
      <!------------------------search end---------------------->
      <el-col :span="24">
        <el-col :span="12">
          <div class="member">
            <IEcharts
              :option="member"
              :loading="memberloading"
            />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="member">
            <IEcharts
              :option="customer"
              :loading="customerloading"
            />
          </div>
        </el-col>
      </el-col>
      <el-col :span="24">
        <el-col :span="12">
          <div class="member">
            <IEcharts
              :option="turnover"
              :loading="turnoverloading"
            />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="member">
            <IEcharts
              :option="category"
              :loading="categoryloading"
            />
          </div>
        </el-col>
      </el-col>
      <el-col :span="24">
        <el-col :span="12">
          <div class="member">
            <IEcharts
              :option="unitprice"
              :loading="unitpriceloading"
            />
          </div>
        </el-col>
        <el-col :span="12">
          <div class="member">
            <IEcharts
              :option="profit"
              :loading="profitloading"
            />
          </div>
        </el-col>
      </el-col>
      <el-col :span="24">
        <h3 style="margin-top:30px;">商品销量走势图</h3>
        <el-form :inline="true" class="demo-form-inline" ref="search" :model="search">
          <el-form-item>
            <el-select 
            v-model="search.brand" 
            filterable
            remote
            multiple
            reserve-keyword
            :remote-method="getBrand"
            :loading="brandLoading"
            style="width:150px"
            placeholder="按品牌">
              <el-option
                v-for="(item,index) in brandlists"
                :key="index"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select> 
          </el-form-item>
          <el-form-item>
            <el-cascader :options="categorylist" v-model="search.catid" placeholder="按分类"></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-select 
            v-model="search.product" 
            filterable
            remote
            reserve-keyword
            :remote-method="getProduct"
            :loading="productLoading"
            placeholder="按单品">
              <el-option
                v-for="(item,index) in productlists"
                :key="index"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select> 
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getTrends">查询</el-button>
          </el-form-item>
        </el-form>

          <div class="member">
            <IEcharts
              :option="trends"
              :loading="trendsloading"
            />
          </div>

      </el-col>
  </div>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full.js';
export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Shop/index",
      sales:[],
      salesLoading:false,
      query:{
        act:'sales',
        token:this.$cookies.get('token'),
        date:[new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-01',new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate()]
      },
      search:{
        act:'trends',
        token:this.$cookies.get('token'),
        brand:[],
        product:'',
        catid:[],
      },
      brandlists:[],
      productlists:[],
      categorylist:[],
      brandLoading:false,
      productLoading:false,
      memberloading: true,
      customerloading: true,
      unitpriceloading: true,
      profitloading:true,
      turnoverloading: true,
      categoryloading: true,
      trendsloading:true,
      member: {
        title: {
          text: '会员分析'
        },
        tooltip: {},
        grid: {
            left: '5%',
            right: '5%',
            bottom: '5%',
            containLabel: true
        },
        xAxis: {
          data: []
        },
        yAxis: {},
        series: [{
          name: '共有会员数',
          type: 'bar',
          data: [],
        }]
      },
      customer: {
        title: {
          text: '客流分析'
        },
        tooltip: {},
        grid: {
            left: '5%',
            right: '5%',
            bottom: '5%',
            containLabel: true
        },
        xAxis: {
          data: []
        },
        yAxis: {},
        series: [{
          name: '接待客户量',
          type: 'bar',
          data: [],
        }]
      },
      unitprice: {
        title: {
          text: '客单价分析'
        },
        tooltip: {},
        grid: {
            left: '5%',
            right: '5%',
            bottom: '5%',
            containLabel: true
        },
        xAxis: {
          data: []
        },
        yAxis: {},
        series: [{
          name: '客单价',
          type: 'bar',
          data: [],
        }]
      },
      profit: {
        title: {
          text: '赢利分析'
        },
        tooltip: {},
        grid: {
            left: '5%',
            right: '5%',
            bottom: '5%',
            containLabel: true
        },
        xAxis: {
          data: []
        },
        yAxis: {},
        series: [{
          name: '赢利',
          type: 'bar',
          data: [],
        }]
      },
      turnover: {
        title: {
          text: '销售额分析'
        },
        tooltip : {
            trigger: 'axis',
            axisPointer : { 
                type : 'shadow'
            }
        },
        legend: {
            data:['总店营业额','商品销售额','服务营业额','寄养营业额']
        },
        grid: {
            left: '5%',
            right: '5%',
            bottom: '5%',
            containLabel: true
        },
        xAxis : [
            {
                type : 'category',
                data : ['最高','最低','平均']
            }
        ],
        yAxis : [
            {
                type : 'value'
            }
        ],
        series : [
            {
                name:'总店营业额',
                type:'bar',
                data:[]
            },
            {
                name:'商品销售额',
                type:'bar',
                data:[]
            },
            {
                name:'服务营业额',
                type:'bar',
                data:[]
            },
            {
                name:'寄养营业额',
                type:'bar',
                data:[]
            }
        ]
      },
      category: {
        title: {
          text: '商品销售分类比例分析'
        },
        tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
            orient: 'vertical',
            left: 'left',
            data: []
        },
        series : [
            {
                name: '分类',
                type: 'pie',
                radius : '70%',
                center: ['50%', '50%'],
                data:[],
                itemStyle: {
                    emphasis: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ]
      },
      trends:{
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data:[]
        },
        grid: {
            left: '2%',
            right: '2%',
            bottom: '5%',
            containLabel: true
        },
        toolbox: {
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: []
        },
        yAxis: {
            type: 'value'
        },
        series: []
      }
    }
  },
  filters: {
    yen: function (value) {
      return '¥'+value
    }
  },
  components: {
    IEcharts
  },
  mounted(){
    this.getMember();
    this.getCustomer();
    this.getUnitPrice();
    this.getProfit();
    this.getTurnover();
    this.getCategory();
    this.getCategoryList();
    this.getTrends();
  },
  methods:{
    searchStat(){
      this.getMember();
      this.getCustomer();
      this.getUnitPrice();
      this.getProfit();
      this.getTurnover();
      this.getCategory();
      this.getCategoryList();
      this.getTrends();
    },
    getMember(){
      var resource = this.$resource(this.url);
      resource.query({ act:'member',date: this.query.date,token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.memberloading=false;
        }else{
          var info = JSON.parse(Base64.decode(res.data.Data));
          this.member.series[0].data = info.value;
          this.member.xAxis.data = info.name;
          this.memberloading=false;
        }
      }).catch((res) => {
          this.memberloading=false;
      });
    },
    getCustomer(){
      var resource = this.$resource(this.url);
      resource.query({ act:'customer',date: this.query.date,token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.customerloading=false;
        }else{
          var info = JSON.parse(Base64.decode(res.data.Data));
          this.customer.series[0].data = info.value;
          this.customer.xAxis.data = info.name;
          this.customerloading=false;
        }
      }).catch((res) => {
          this.customerloading=false;
      });
    },
    getUnitPrice(){
      var resource = this.$resource(this.url);
      resource.query({ act:'unitprice',date: this.query.date,token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.unitpriceloading=false;
        }else{
          var info = JSON.parse(Base64.decode(res.data.Data));
          this.unitprice.series[0].data = info.value;
          this.unitprice.xAxis.data = info.name;
          this.unitpriceloading=false;
        }
      }).catch((res) => {
          this.unitpriceloading=false;
      });
    },
    getProfit(){
      var resource = this.$resource(this.url);
      resource.query({ act:'profit',date: this.query.date,token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.profitloading=false;
        }else{
          var info = JSON.parse(Base64.decode(res.data.Data));
          this.profit.series[0].data = info.value;
          this.profit.xAxis.data = info.name;
          this.profitloading=false;
        }
      }).catch((res) => {
          this.profitloading=false;
      });
    },
    getTurnover(){
      var resource = this.$resource(this.url);
      resource.query({ act:'turnover',date: this.query.date,token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.turnoverloading=false;
        }else{
          var info = JSON.parse(Base64.decode(res.data.Data));
          this.turnover.series[0].data = info.turnover;
          this.turnover.series[1].data = info.product;
          this.turnover.series[2].data = info.service;
          this.turnover.series[3].data = info.foster;
          this.turnoverloading=false;
        }
      }).catch((res) => {
          this.turnoverloading=false;
      });
    },
    getCategory(){
      var resource = this.$resource(this.url);
      resource.query({ act:'category',date: this.query.date,token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.categoryloading=false;
        }else{
          var info = JSON.parse(Base64.decode(res.data.Data));
          if(info!='' && info!=null){
            this.category.series[0].data = info;
          }
          this.categoryloading=false;
        }
      }).catch((res) => {
          this.categoryloading=false;
      });
    },
    getTrends(){
      this.trendsloading=true;
      var resource = this.$resource(this.url);
      resource.query(this.search).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.trendsloading=false;
        }else{
          var info = JSON.parse(Base64.decode(res.data.Data));
          this.trends.legend.data = info.legend;
          this.trends.xAxis.data = info.xAxis;
          this.trends.series = info.series;
          this.trendsloading=false;
        }
      }).catch((res) => {
          this.trendsloading=false;
      });
    },
    //获取品牌
    getBrand(query){
      if (query !== '') {
        this.brandLoading = true;
        var resource = this.$resource(this.url);
        resource.query({act:'getbrand',key:query,token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
            if(res.data.Result=='70001'){
              this.$router.push('/login')
            }
            this.$message.error(res.data.Message);
            this.brandLoading = false;
          }else{
            this.brandlists = JSON.parse(Base64.decode(res.data.Data));
            this.brandLoading = false;
          }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.brandLoading = false;
        });
      }
    },
    //获取分类列表
    getCategoryList(){
      var resource = this.$resource(this.url);
      resource.query({ act:'getcategorylist',token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.categorylist = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    //获取商品
    getProduct(query){
      if (query !== '') {
        this.productLoading = true;
        var resource = this.$resource(this.url);
        resource.query({act:'getproduct',key:query,token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
            if(res.data.Result=='70001'){
              this.$router.push('/login')
            }
            this.$message.error(res.data.Message);
            this.productLoading = false;
          }else{
            this.productlists = JSON.parse(Base64.decode(res.data.Data));
            this.productLoading = false;
          }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.productLoading = false;
        });
      }
    },
  }
}
</script>
<style>
.report-box{border:1px solid #DCDFE6;border-radius:5px;padding-left:25px;}
.report-box h5{color:#666;font-weight:100;}
.report-box h2{color:#409EFF;}
.member{width:100%;height:400px;margin-top:30px;}
</style>


// WEBPACK FOOTER //
// src/components/shop/stat.vue